import React from 'react';
import PropTypes from 'prop-types';
import Notification from '~/components/Notification';
import {Button, Link, Stack} from '@customink/pigment-react';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export default function UploadDimensionsError(props) {
  const {dismiss} = props;
  return (
    <Notification
      {...props}
      title={
        <span>
          <span>Oops!</span> <span>Your file is too large.</span>
        </span>
      }>
      <p>
        Please resize your file to below 10,000px or{' '}
        <span>
          <Link href="#/help" onClick={dismiss}>
            contact us
          </Link>{' '}
          for help.
        </span>
      </p>
      <Stack className="notification-stack">
        <Button
          className="notification-cta"
          size="large"
          variant="secondary"
          onClick={dismiss}>
          Close
        </Button>
      </Stack>
    </Notification>
  );
}

const propTypes = {
  dismiss: PropTypes.func
};

UploadDimensionsError.propTypes = propTypes;

UploadDimensionsError.displayName = 'UploadDimensionsError';
